// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT DIRECTLY.

import BadgeData from "entity/BadgeData";
import SocialMeta from "./SocialMeta";
import SocialPermissionType from "enums/SocialPermissionType";
import SocialPlatformType from "enums/SocialPlatformType";
import SocialTheme, { processSocialTheme } from "./SocialTheme";
import User, { processUser, processUserArray } from "./User";
import Util from "PreciateUtil";

export default interface Social {
    socialId?: string;
    socialRoomSetId?: string;
    userId?: string;
    companyId?: string;
    name?: string;
    description?: string;
    socialURI?: string;
    sessionId?: string;
    isOpen?: boolean;
    recurring?: boolean;
    anyoneCanStart?: boolean;
    isValid?: boolean;
    free?: boolean;
    allowGuestUsers?: boolean;
    user?: User;
    socialPermissionType?: SocialPermissionType;
    platform?: SocialPlatformType;
    maxParticipants?: number;
    startingWidth?: number;
    startingHeight?: number;
    hostAdmitted?: boolean;
    themeId?: string;
    configurationId?: string;
    theme?: SocialTheme;
    playlistId?: string;
    artifactSetId?: string;
    startDateTime?: Date;
    endDateTime?: Date;
    dateCreated?: Date;
    companyName?: string;
    socialMeta?: SocialMeta;
    connectedRoom?: boolean;
    updatedByUser?: User;
    updatedDateTime?: Date;
    alternateHosts?: User[];
    myBadgeData?: BadgeData[];
}

export function processSocial(value?: Social): void {
  if (value) {
    value.startDateTime = Util.toDate((value as any).startDateTime);
    value.endDateTime = Util.toDate((value as any).endDateTime);
    value.dateCreated = Util.toDate((value as any).dateCreated);
    value.updatedDateTime = Util.toDate((value as any).updatedDateTime);
    processUser(value.user);
    processSocialTheme(value.theme);
    processUser(value.updatedByUser);
    processUserArray(value.alternateHosts);
  }
}

export function processSocialArray(array?: Social[]): void {
  if (array) {
    for (const v of array) {
      processSocial(v);
    }
  }
}
